import { http } from "@/communication";

export const searchModule = {
  namespaced: true,
  state: {
    result: [],
    filter: {
      interested_in_gender: null,
      age_from: 18,
      age_to: 39,
      is_online: true,
      has_picture: false,
      has_erotic_picture: false,
      order: "newest",
      location: "",
      postcode: "",
      distance: 100,
      i_search_for_activity: [0, 1, 2, 3],
      take: 10
    },
    proposals: []
  },
  actions: {
    async read({ commit, rootState }, filterData) {
      if (!filterData) filterData = rootState.search.filter;
      await http
        .post("/api/v1/customerProfile/filter", filterData)
        .then(({ data }) => {
          commit("persist", filterData);
          if (data) {
            commit("create", data);
          }
        })
        .catch(error => {
          console.log("search error", error);
        });
    },
    async search({ commit, rootState }, filterData) {
      filterData
        ? commit("persist", filterData)
        : (filterData = rootState.search.filter);
      await http
        .post("/api/v1/customerProfile/filter", filterData)
        .then(({ data }) => {
          if (data) {
            commit("updateResults", data);
          }
        })
        .catch(error => {
          console.log("search error", error);
        });
    },
    async proposals({ commit }) {
      await http
        .get("/api/v1/customerProfile/proposal")
        .then(({ data }) => {
          if (data) {
            commit("updateProposals", data);
          }
        })
        .catch(error => {
          console.log("search error", error);
        });
    }
  },
  mutations: {
    create(state, data) {
      state.result = data;
    },
    updateFilter(state, { key, value }) {
      state.filter[key] = value;
    },
    updateResults(state, data) {
      state.result
        ? (state.result = state.result.concat(data))
        : (state.result = data);
    },
    updateProposals(state, data) {
      state.proposals = data;
    },
    persist(state, filterData) {
      state.filter = filterData;
    },
    resetPostcode(state) {
      state.filter.postcode = "";
    }
  },
  getters: {
    result({ result }) {
      return result;
    },
    filter({ filter }) {
      return filter;
    },
    filterprop: ({ filter }) => key => {
      return key === "age" ? [filter.age_from, filter.age_to] : filter[key];
    },
    proposed(state) {
      return state.proposals;
    }
  }
};
